import React from "react";
import "./Skeleton.scss";

/**
 * {"text"|"circle"|"rect"|"button"|"input"} type
 * {string} width
 * {string} height
 * {string} className
 * {number} lines  - Solo para type="text", renderiza varias líneas
 */
const Skeleton = ({ type = "text", width, height, className = "", lines = 1 }) => {
    if (type === "text" && lines > 1) {
        return (
            <div className={`skeleton-lines ${className}`} style={{ width }}>
                {Array.from({ length: lines }).map((_, i) => (
                    <div
                        key={i}
                        className="skeleton skeleton--text"
                        style={{ width: i === lines - 1 ? "65%" : "100%" }}
                    />
                ))}
            </div>
        );
    }

    return (
        <div
            className={`skeleton skeleton--${type} ${className}`}
            style={{ width, height }}
        />
    );
};

export default Skeleton;